import { Component, Input } from '@angular/core';
import { DVFormGroup } from 'src/app/shared/helpers/dynamic-validators/dynamic-validator';


@Component({
  selector: 'app-add-package-activity',
  templateUrl: './add-package-activity.component.html',
  styleUrls: ['./add-package-activity.component.css']
})
export class AddPackageActivityComponent {
  @Input() index: number;
  @Input() packageDayForm: DVFormGroup;
}
